import React from 'react';
import {
	Container,
	Box,
	Grid,
	Paper,
	Divider,
	TableContainer,
	Table,
	TableHead,
	TableBody,
	TableRow,
	Avatar,
	withStyles,
	TableCell,
} from '@material-ui/core';
import BodyText from './BodyText';
import TitleText from './TitleText';
import DashboardTable from './DashboardTable';
import DashboardTable2 from './DashboardTable2';
import { color, data } from '../../constants';
import SummaryBox from '../summary-box/SummaryBox';
import { useSelector } from 'react-redux';
const tableHeaders = [
	'Type',
	'Order ID',
	'Depart From',
	'Journey To',
	'Order Date',
	'Journey Date',
	'Ticket Cost',
	'Status',
	'Details',
];
const tableHeaders2 = [
	'Type',
	'Transaction Date',
	'Transaction Amount',
	// 'Description',
	'Commission',
	'Markup',
	'Payment Type',
];
const StyledTableCell = withStyles((theme) => ({
	head: {
		fontWeight: 600,
		color: '#8C8C8C',
		padding: 3,
		fontSize: 18,
	},
	root: {
		borderBottom: 'none',
		paddingBottom: 0,
	},
}))(TableCell);

const Das = () => {
	const { wallet, walletagent } = useSelector((state) => state.user);
	return (
		<>
			<Grid container spacing={2}>
				<Grid item sm={12} md={12} lg={8}>
					<Grid container spacing={2}>
						{data.summary.map((item, index) => (
							<Grid item xs={12} sm={6} md={6} lg={6}>
								<SummaryBox item={item} />
							</Grid>
						))}
					</Grid>
					{/* <Grid container>
						<Grid item xs={12}></Grid>
					</Grid> */}
					{/* <Grid container>
						<Grid
							item
							xs={12}
							style={{
								boxShadow: '5px 5px 30px rgba(3, 98, 175, 0.1)',
								borderRadius: 15,
								marginTop: 20,
								backgroundColor: 'white',
								padding: 15,
							}}>
							<Box display='flex' justifyContent='space-between'>
								<BodyText
									two
									textStyle={{
										fontWeight: 700,
										color: '#00325B',
										opacity: 0.45,
									}}>
									Transaction History
								</BodyText>
								<Box display='flex' alignItems='center'>
									<Box
								
									>
										<BodyText
											one
											textStyle={{
												fontWeight: 600,
												cursor: 'pointer',
											}}>
											View All{' '}
											<Divider style={{ backgroundColor: '#00325B' }} />
										</BodyText>
									</Box>
								</Box>
							</Box>
							<TableContainer style={{ marginTop: 15 }}>
								<Table>
									<TableHead>
										<TableRow>
											{tableHeaders2.map((title, index) => (
												<StyledTableCell key={title}>{title}</StyledTableCell>
											))}
										</TableRow>
									</TableHead>
									<TableBody>
										
										{[0, 1, 2].map((i, index) => {
											return <DashboardTable2 rowIndex={index} />;
										})}
									</TableBody>
								</Table>
							</TableContainer>
						</Grid>
					</Grid> */}
				</Grid>
				<Grid item xs={12} sm={12} md={12} lg={4}>
					<Grid container style={{ height: '100%' }}>
						<Grid
							item
							xs={12}
							style={{
								boxShadow: '5px 5px 30px rgba(3, 98, 175, 0.1)',
								borderRadius: 15,
								padding: 12,
								backgroundColor: 'white',
							}}>
							<Box
								mt={'30px'}
								display='flex'
								justifyContent='center'
								alignItems='center'>
								<TitleText
									textStyle={{
										fontSize: 25,
										fontFamily: 'Josefin Sans, sans-serif',
									}}>
									TOTAL AMOUNT
								</TitleText>
							</Box>
							<Box
								mt={'63px'}
								display='flex'
								justifyContent='center'
								alignItems='center'>
								<TitleText
									textStyle={{
										fontSize: 30,
										color: 'red',
										fontFamily: 'Josefin Sans, sans-serif',
									}}>
									₹{' '}
									{wallet
										? wallet && wallet.result && wallet.result.balanceAmount
										: walletagent
										? walletagent &&
										  walletagent.result &&
										  walletagent.result.balanceAmount
										: ''}
								</TitleText>
							</Box>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</>
	);
};

export default Das;
